import classNames from 'classnames';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { StylesheetContext } from '../../contexts/StylesheetContext';
import { TicketContext } from '../../contexts/TicketContext';
import { TicketRoutePaths } from '../../interfaces/Routes';
import { isSFChatAvailable } from '../../services/ChatService';
import StepsService from '../../services/StepsService';
import Button from '../Button/Button';
import style from './FAQComponent.module.scss';
import { SmallFAQCallContainer } from './SmallFAQCallContainer';

export const FAQComponent: FC = () => {
  const { ticket } = useContext(TicketContext);
  const { stylesheet: { contact: { showPhoneNumberInFooter, showFaqInFooter } } } = useContext(StylesheetContext);
  const fullRowWidth = !isSFChatAvailable();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (fullRowWidth || showPhoneNumberInFooter) {
    return (
      <SmallFAQCallContainer fullRowWidth={fullRowWidth} renderFAQ={showFaqInFooter} renderPhone={showPhoneNumberInFooter}/>
    );
  }

  // in case when only FAQ is shown in the footer, it completely changes the layout between desktop / mobile.
  // for this reasons we render both Components to show FAQ link but proper version will be rendered

  return (
    <>
      <div className={classNames({
        [style.desktopOnly]: !showPhoneNumberInFooter,
      })}>
        <img alt="whatsapp" height={64} src="/assets/faq.png" width={64} />

        <div className={style.content}>
          <div className={style.headerRow}>
            <span className={style.header}>{t('contact:contactPageLink')}</span>
          </div>

          <p className={style.p}>{t('contact:contactPageLinkDescription')}</p>

          <Button
            onClick={() => {
              navigate(StepsService.getStepUri(ticket?.hashId, TicketRoutePaths.contact));
            }}
            text={t('contact:contactPageButton')}
            variant="outline"
          />
        </div>
      </div>
      <SmallFAQCallContainer fullRowWidth={fullRowWidth} mobileOnly renderFAQ={showFaqInFooter} renderPhone={false}/>
    </>

  );
};
